import { formatNumber } from "src/MarketDataComponents/Helpers";
import { useRouter } from 'next/router';
import Axios from 'axios';
import { YouInvest } from 'src/Api';
import { formatDate } from 'src/Utils';

export default function TopHoldings({holdings, date}) {
    const router = useRouter();

    const clickHandler = (e, holding) => {
        e.preventDefault();

        if (!holding.sedol) {
            if(holding.isin) {
                Axios({
                    method: 'GET',
                    url: `/api/securities/search?isin=${holding.isin}`,
                    headers: YouInvest.getTradingRequestHeaders()
                }).then(response => {;
                    router.push(`/${response.data.data.results[0].marketCode}`);
                }).catch(error => {});
            }
            
            return;
        }
        
        if (holding.holdingType === "FO") {
            router.push(`FUND:${holding.sedol}`);
        } else {
            Axios({
                method: 'GET',
                url: `/api/securities/instrument?sedol=${holding.sedol}`,
                headers: YouInvest.getTradingRequestHeaders()
            }).then(response => {
                router.push(`/${response.data.data.marketCode}`);
            }).catch(error => {});
        }
    }



    const renderRows = () => {
        const formattedDate = formatDate(date);
        return holdings.map((holding, index) => {
            return <tr key={index}>
                <td scope="row" aria-label={"Holdings " + formattedDate}>
                    <a href="" onClick={(e) => clickHandler(e, holding)}>{holding.name}</a>
                </td>
                <td aria-label="% of Assets">{formatNumber(holding.weighting, 2)}</td>
            </tr>
        });
    }

    return <div className="card z-depth-0 margin-0">
        <div className="card-content padding-top-0-sm padding-right-0-sm padding-bottom-30-sm padding-left-0-sm">
            <h2 className="card-title">Top 10 Holdings</h2>
            <table className="data-table data-table--small data-table--scroll margin-0">
                <thead>
                    <tr>
                        <th>Holdings {formatDate(date)}</th>
                        <th>% of assets</th>
                    </tr>
                </thead>
                <tbody>
                    {renderRows()}
                </tbody>
            </table>
        </div>
    </div>
}